import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, finalize, switchMap, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { inject } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../../features/auth/services/auth';
import { Router } from '@angular/router';
import { getFirstAllowedRoute } from '../guards/permission-guard';
// import { AuthService } from '../../features/auth/services/auth.service';

export const JwtInterceptor: HttpInterceptorFn = (req, next) => {
  const spinner = inject(NgxSpinnerService);
  const toaster = inject(ToastrService);
  const service = inject(AuthService);
  const router = inject(Router);
  const authToken = localStorage.getItem('ShuwierToken');

  // Fetch language using the TranslationService
  spinner.show();
  const authReq = req.clone({
    setHeaders: {
      Authorization: authToken ? `Bearer ${authToken}` : '',
      // lang: 'en',
    },
  });
  // const authReq = authToken
  //   ? req.clone({ setHeaders: { Authorization: `Bearer ${authToken}` } })
  //   : req;

  return next(authReq).pipe(
    // catchError((err: any) => {
    //   if (err instanceof HttpErrorResponse) {
    //     window.scrollTo({
    //       top: 0,
    //       behavior: 'smooth',
    //     });

    //     if (err.status === 401 || err.status === 403) {

    //       const isAuthRequest =
    //         req.url.includes('/auth/login') ||
    //         req.url.includes('/auth/logout');

    //       if (!isAuthRequest) {
    //         service.clearSession();
    //         router.navigate(['/login']);
    //         toaster.error(
    //           err?.error?.message || 'Session Expired Please Login Again'
    //         );
    //       }
    //     }

    //     toaster.error('', err.error.message);
    //   }
    //   return throwError(() => err);
    // }
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {

        const skipToast =
          req.headers.get('Skip-Error-Toast') === 'true';

        // if (err.status === 401) {
        //   const isAuthRequest = req.url.includes('/auth/login') || req.url.includes('/auth/logout');

        //   if (!isAuthRequest) {
        //     service.logoutLocal();
        //     // router.navigate(['/login']);
        //     toaster.error(err?.error?.message || 'Session Expired Please Login Again');
        //   }
        // } 
        if (err.status === 401) {

          const isLoginRequest = req.url.includes('/auth/login');
          const isLogoutRequest = req.url.includes('/auth/logout');
          const isRefreshRequest = req.url.includes('/auth/refresh');

          if (isLoginRequest || isLogoutRequest) {
            return throwError(() => err);
          }

          // Refresh endpoint itself failed
          if (isRefreshRequest) {
            service.logoutLocal();
            router.navigate(['/login']);
            toaster.error('Session expired. Please login again.');
            return throwError(() => err);
          }

          const token = localStorage.getItem('ShuwierToken');

          // No access token -> don't even try refresh 
          if (!token) {
            console.log("from no token");
            
            service.logoutLocal();
            router.navigate(['/login']);
            toaster.error('Session expired. Please login again.');
            return throwError(() => err);
          }

          else if(token){
            console.log("Token", token);
            
          // Token exists -> try refresh
          return service.refreshAndUpdateSession().pipe(

            // Refresh succeeded
            switchMap(() => {
              const permissions =
                service.currentUser()?.admin?.permissions_with_role?.permissions ?? [];

              router.navigateByUrl(getFirstAllowedRoute(permissions));

              // No retry of the original request
              return throwError(() => err);
            }),

            // Refresh failed
            // catchError((refreshError: HttpErrorResponse) => {

            //   service.logoutLocal();
            //   router.navigate(['/login']);
            //   toaster.error('Session expired. Please login again.');

            //   return throwError(() => refreshError);
            // })
          );
        }
        }
        else if (err.status === 404) {
          router.navigate(['/not-found']);
          toaster.error(err?.error?.message || 'You do not have permission to access this page');
        } else if (!skipToast) {
          toaster.error('', err.error.message);
        }
      }

      return throwError(() => err);
    }
    ), finalize(() => {
      spinner.hide();
    }),

  );
};
